/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  FetchOpenAPIv3FromURLForm2,
  FetchOpenAPIv3FromURLForm2$Outbound,
  FetchOpenAPIv3FromURLForm2$outboundSchema,
} from "../components/fetchopenapiv3fromurlform2.js";

export type FetchOpenAPIv3FromURLSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type FetchOpenAPIv3FromURLSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type FetchOpenAPIv3FromURLSecurity = {
  option1?: FetchOpenAPIv3FromURLSecurityOption1 | undefined;
  option2?: FetchOpenAPIv3FromURLSecurityOption2 | undefined;
};

export type FetchOpenAPIv3FromURLRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  fetchOpenAPIv3FromURLForm2: FetchOpenAPIv3FromURLForm2;
};

/** @internal */
export type FetchOpenAPIv3FromURLSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const FetchOpenAPIv3FromURLSecurityOption1$outboundSchema: z.ZodMiniType<
  FetchOpenAPIv3FromURLSecurityOption1$Outbound,
  FetchOpenAPIv3FromURLSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function fetchOpenAPIv3FromURLSecurityOption1ToJSON(
  fetchOpenAPIv3FromURLSecurityOption1: FetchOpenAPIv3FromURLSecurityOption1,
): string {
  return JSON.stringify(
    FetchOpenAPIv3FromURLSecurityOption1$outboundSchema.parse(
      fetchOpenAPIv3FromURLSecurityOption1,
    ),
  );
}

/** @internal */
export type FetchOpenAPIv3FromURLSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const FetchOpenAPIv3FromURLSecurityOption2$outboundSchema: z.ZodMiniType<
  FetchOpenAPIv3FromURLSecurityOption2$Outbound,
  FetchOpenAPIv3FromURLSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function fetchOpenAPIv3FromURLSecurityOption2ToJSON(
  fetchOpenAPIv3FromURLSecurityOption2: FetchOpenAPIv3FromURLSecurityOption2,
): string {
  return JSON.stringify(
    FetchOpenAPIv3FromURLSecurityOption2$outboundSchema.parse(
      fetchOpenAPIv3FromURLSecurityOption2,
    ),
  );
}

/** @internal */
export type FetchOpenAPIv3FromURLSecurity$Outbound = {
  Option1?: FetchOpenAPIv3FromURLSecurityOption1$Outbound | undefined;
  Option2?: FetchOpenAPIv3FromURLSecurityOption2$Outbound | undefined;
};

/** @internal */
export const FetchOpenAPIv3FromURLSecurity$outboundSchema: z.ZodMiniType<
  FetchOpenAPIv3FromURLSecurity$Outbound,
  FetchOpenAPIv3FromURLSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => FetchOpenAPIv3FromURLSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => FetchOpenAPIv3FromURLSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function fetchOpenAPIv3FromURLSecurityToJSON(
  fetchOpenAPIv3FromURLSecurity: FetchOpenAPIv3FromURLSecurity,
): string {
  return JSON.stringify(
    FetchOpenAPIv3FromURLSecurity$outboundSchema.parse(
      fetchOpenAPIv3FromURLSecurity,
    ),
  );
}

/** @internal */
export type FetchOpenAPIv3FromURLRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Session"?: string | undefined;
  FetchOpenAPIv3FromURLForm2: FetchOpenAPIv3FromURLForm2$Outbound;
};

/** @internal */
export const FetchOpenAPIv3FromURLRequest$outboundSchema: z.ZodMiniType<
  FetchOpenAPIv3FromURLRequest$Outbound,
  FetchOpenAPIv3FromURLRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    fetchOpenAPIv3FromURLForm2: FetchOpenAPIv3FromURLForm2$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      gramSession: "Gram-Session",
      fetchOpenAPIv3FromURLForm2: "FetchOpenAPIv3FromURLForm2",
    });
  }),
);

export function fetchOpenAPIv3FromURLRequestToJSON(
  fetchOpenAPIv3FromURLRequest: FetchOpenAPIv3FromURLRequest,
): string {
  return JSON.stringify(
    FetchOpenAPIv3FromURLRequest$outboundSchema.parse(
      fetchOpenAPIv3FromURLRequest,
    ),
  );
}
